'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = _entries;

var _total2 = require('./_total');

var _total3 = _interopRequireDefault(_total2);

var _list2 = require('./_list');

var _list3 = _interopRequireDefault(_list2);

var _expand2 = require('./_expand');

var _expand3 = _interopRequireDefault(_expand2);

var _isState = require('../status/is-state');

var _isState2 = _interopRequireDefault(_isState);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _resourceState(root, id) {
    if (!root || !root.resources || !root.resources[id]) return null;

    var entry = root.resources[id];
    return entry.state;
}

function _entries(root, listName, start, end) {
    var list = (0, _list3.default)(root, listName);
    var entries = list.entries;
    var total = (0, _total3.default)(list);

    start = Math.max(start, 0);
    end = Math.min(total, end + 1);

    if (start >= total) return [];

    var count = end - start;
    var result = entries.slice(start, end).map(function (entry) {
        if (!(0, _isState2.default)(entry, _constants.OK)) return entry;

        var state = _resourceState(root, entry && entry.id);
        if (!state) return null;

        return (0, _extends3.default)({}, entry, { state: state });
    });

    if (result.length == count) return result;

    return (0, _expand3.default)(result, count);
}